export default {
      id: "icon-studio-red-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-studio-red",
      toString: function () {
        return this.url;
      }
    }